export default __webpack_public_path__ + "static/media/guarddestroyer3.3f6d353c.png";